<div class="w-full flex justify-content-center">
    <!--payment successful begin-->
    <div *ngIf="processState === 'success'" class="w-6 flex flex-column align-items-center">
        <div class="card mt-3 w-30rem">
            <div class="w-full flex justify-content-center">
                <p>&nbsp;</p>
                <img src="../../../assets/images/sipo/okimza.svg" class="image-state w-full">

            </div>
            <div class="w-full">
                <div class="font-bold text-4xl flex justify-content-center">
                    {{ 'sipo.payment-component.result-component.order-successful' | translate }}
                </div>
                <div class="flex justify-content-center text-lg">
                    {{ 'sipo.payment-component.result-component.order-successful-message' | translate }}
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="w-full flex align-items-center justify-content-center mb-4">
                <button
                    [routerLink]="['/']"
                    class="p-button p-button-secondary p-button-outlined">
                    {{ 'sipo.payment-component.result-component.back-to-home' | translate }}
                </button>
            </div>

        </div>
    </div>
    <!--payment successful end-->
    <!--error occurred begin-->
    <div *ngIf="processState === 'error'" class="w-6 flex flex-column align-items-center">
        <div class="w-full overflow-hidden relative">
            <div class="w-full h-15rem"></div>

            <img src="../../../assets/images/sipo/nokimza.svg" class="image-state w-full">

        </div>
        <div class="w-full">
            <div class="font-bold text-4xl flex justify-content-center">
                {{ 'sipo.payment-component.result-component.error-occurred' | translate }}
            </div>
            <div class="flex justify-content-center text-lg">
                {{ 'sipo.payment-component.result-component.error-occurred-message' | translate }}
            </div>
        </div>
    </div>
    <!--error occurred end-->
</div>
